import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useCloneStudyGame(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation(
    async ({gameId, name}: {gameId: string; name?: string}) => {
      const response = await ChessRestClient.post(
        `learning/study_games/${gameId}/clone/`,
        name ? {name} : {},
      );
      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}
